/* unplugin-vue-components disabled */
// do not use <script setup> here
// we call methods on this component
import UrlsList from './urls-list.vue'
import {GenrateTextarea} from 'components/genrate'
import {AVATAR} from 'consts/ftypes.js'
import Uploader from 'components/uploader'

const __default__ = {
  components: {UrlsList, GenrateTextarea, Uploader},
  inject: {
    store: {default: undefined}
  },
  props: {
    opts: {type: Array, required: true},
    row: {type: Boolean, default: false},
    gap: {type: String, default: '2.4rem'},
    propstore: {type: Object, default: undefined}
  },
  emits: ['update', 'update:valid'],
  data() {
    return {
      inputs_validity: Array(this.opts.length).fill(true),
      AVATAR
    }
  },
  computed: {
    valid () {
      return this.inputs_validity.indexOf(false) === -1
    },
    my_store() {
      return this.propstore || this.store
    }
  },
  methods: {
    onTabChange(prop, input_idx) {
      this.$nextTick(() => {
        // because we use v-if tab_inputs always have 1 element
        this.inputs_validity[input_idx] = this.$refs[`tab_inputs_${input_idx}`][0].valid
        this.onUpdate(prop)
      })
    },
    onUpdate(prop) {
      this.$emit('update', prop)
    },
    onAvatarUploaded(item, file) {
      this.my_store[item.field] = file.id
      this.$emit('update', item.field)
    },
    onAvatarRemoved(item) {
      this.my_store[item.field] = null
      this.$emit('update', item.field)
    },
    onMultiselectAdd(item, value) {
      value = value.toLowerCase()
      const curr_val = this.my_store[item.field]
      if (item.max_selections > curr_val.length) {
        this.my_store[item.field] = [...curr_val, value]
        this.$emit('update', item.field)
      }
    },
    onTextAppend(item, value) {
      this.my_store[item.field] = $utils.str.trim_to(this.my_store[item.field] + ' ' + value.replaceAll('\n', ' '), item.maxlength)
      this.$emit('update', item.field)
    },
    onTextReplace(item, value) {
      this.my_store[item.field] = $utils.str.trim_to(value.replaceAll('\n', ' '), item.maxlength)
      this.$emit('update', item.field)
    },
    optionDescription(item) {
      return item.opts?.find(opt => opt.value === this.my_store[item.field])?.description
    },
    classnames(item) {
      return [
        ...(typeof item.className === 'string' ? [item.className] : (item.className || []))
      ]
    },
    fieldStyles(item, idx) {
      return {
        marginBottom: !this.row && idx !== this.opts.length - 1 && this.fieldGap(item, idx), 
        ...item.style || {}
      }
    },
    fieldGap(field, idx) {
      let gap = 0

      // return gap that is included in control
      // for example when chars coutner is present
      switch(field.type) {
        case 'command':
        case 'identifier':
        case 'text': gap = 2; break
        case 'number': gap = 1; break
      }
      return `calc(${this.gap} - ${gap}rem)`
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "4db90bdf-gap": (_ctx.gap)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__